<template>
  <div class="back-btn">
    <el-button @click="$router.go(-1)">返回</el-button>
  </div>
</template>
<script>
export default {
  name: 'backButton'
}
</script>
<style lang="less" scoped>
  .back-btn {
    width: calc(100% + 20px);
    height: 46px;
    margin-left: -10px;
    background: #FFFFFF;
    box-shadow: 0px 2px 2px 0px rgba(215, 215, 215, 0.4);
    .el-button {
      width: 120px;
      height: 40px;
      margin-left: 10px;
    }
  }
</style>